import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { trackEvent, navigatedToPage } from '../../redux/actions/segmentEvents';
import { fetchCards } from '../../redux/actions/cards';
import { getAccessToken } from '../../selectors/auth';
import { RegistrationWrapper, OfferPaymentWrapper } from '../../containers';
import {
  RailCTA,
  MobileRailCTA,
  LeftRail,
  RightRail,
  OfferHeader,
  RegistrationSubtitle,
  FunnelHelmet,
  FacebookLogin,
  PremiumSuccess,
} from '../../components';
import en from '../../international/translations/en';
import config from '../../config';

class Offer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registrationRendered: false,
      checkoutRendered: false,
      promotionId: config.funnelConfig ? config.funnelConfig._id : null
    };
    this.props.doNavigatedToPage(
      'Funnel',
      'Offer',
      { promotionId: this.state.promotionId },
      { Wootric: false }
    );
  }

  viewedCheckout = () => {
    if (!this.state.checkoutRendered) {
      const { promotionId } = this.state;
      this.setState({ checkoutRendered: true });
      this.props.doTrackEvent('Viewed Checkout Step', { step: 2, promotionId });
    }
  };

  viewedRegistration = () => {
    if (!this.state.registrationRendered) {
      const { promotionId } = this.state;
      this.setState({ registrationRendered: true });
      this.props.doTrackEvent('Viewed Checkout Step', { step: 1, promotionId });
    }
  };

  registrationSuccess = async () => {
    const { doFetchCards } = this.props;
    await doFetchCards();
  };

  renderRegistrationForm = () => {
    const { doToggleForm } = this.props;
    return (
      <RegistrationWrapper
        showLogin
        formLocation="upgrade"
        viewedRegistration={this.viewedRegistration}
        successCallback={this.registrationSuccess}
      >
        <FunnelHelmet showLogin />
        <OfferHeader>
          <RegistrationSubtitle
            showLogin
            doToggleForm={doToggleForm}
          />
        </OfferHeader>
        <FacebookLogin
          formLocation="upgrade"
          successCallback={this.registrationSuccess}
        />
      </RegistrationWrapper>
    );
  };

  renderOfferForm = () => {
    const { success } = this.props;
    if (success) return <PremiumSuccess />;
    return (
      <OfferPaymentWrapper
        viewedCheckout={this.viewedCheckout}
      >
        <OfferHeader isLoggedIn />
      </OfferPaymentWrapper>
    );
  }

  render() {
    const { accessToken } = this.props;
    const ctaCopy = {
      ...en.rail_cta,
      ...en.premiumFeatures,
    };

    return (
      <div className="offer-funnel upgrade-funnel">
        <MobileRailCTA copy={ctaCopy} />
        <LeftRail>
          <div className="upgrade-funnel__content">
            <div>
              {accessToken
                ? this.renderOfferForm()
                : this.renderRegistrationForm()}
            </div>
          </div>
        </LeftRail>
        <RightRail>
          <RailCTA copy={ctaCopy} />
        </RightRail>
      </div>
    );
  }
}

Offer.propTypess = {
  accessToken: PropTypes.string,
  success: PropTypes.bool,
  doTrackEvent: PropTypes.func.isRequired,
  doNavigatedToPage: PropTypes.func.isRequired,
  doFetchCards: PropTypes.func.isRequired,
};
Offer.defaultProps = {
  accessToken: null,
  success: false,
};

export default connect(
  state => ({
    accessToken: getAccessToken(state),
    success: state.offer.success,
  }),
  dispatch => ({
    doTrackEvent: (name, properties) => dispatch(trackEvent(name, properties)),
    doNavigatedToPage: (name, category, properties, integrations) =>
      dispatch(navigatedToPage(name, category, properties, integrations)),
    doFetchCards: () => dispatch(fetchCards()),
  }),
)(Offer);
